// components/HeroSection.js
import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Box, Typography } from '@mui/material';
import FirstBanner from '../assetts/images/banner3.jpg'; // Update paths for your images
import LogoGameZone from '../assetts/icons/logo-game-zone-vip.png';
import LogoGameZonemobile from '../assetts/icons/ffff.png';
import Banner3 from '../assetts/images/bg11.jpg';
import Banner4 from '../assetts/images/ps-banner.jpg';

function HeroSection() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600); // Determine if the screen size is mobile

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600); // Update state based on window size
    };

    window.addEventListener('resize', handleResize); // Add resize event listener

    return () => {
      window.removeEventListener('resize', handleResize); // Cleanup listener on unmount
    };
  }, []);

  // Define mobile and desktop images
  const firstSlideImage = isMobile
    ? `url(${LogoGameZonemobile})`
    : `url(${LogoGameZone})`;

  return (
    <Box
      sx={{
        position: 'relative',
        textAlign: 'center',
        color: '#fff',
        mb: 4,
        mt: 3,
        height: '60vh',
      }}
    >
      <Swiper
        spaceBetween={30}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        style={{
          width: '100%',
          paddingTop: '20px',
          paddingBottom: '20px',
        }}
      >
        {/* First Slide */}
        <SwiperSlide
          style={{
            backgroundImage: firstSlideImage,
            backgroundSize: 'cover', // Ensure the image covers the entire area
            backgroundPosition: 'center',
            height: '50vh',
          }}
        >
          <Box
            sx={{
              p: 5,
              backdropFilter: 'brightness(0.7)',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
            }}
          ></Box>
        </SwiperSlide>

        {/* Second Slide */}
        <SwiperSlide
          style={{
            backgroundImage: `url(${Banner4})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '60vh',
            borderRadius: '15px',
            display: 'flex',
            alignItems: 'start',
            justifyContent: 'center',
            position: 'relative',
            color: '#ffffff',
            textAlign: 'center',
            overflow: 'hidden',
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
              letterSpacing: '2px',
              color: '#ffff',
              background: 'linear-gradient(to bottom, #0000005a, #fffcfc)', // Black to silver gradient
              backgroundClip: 'text',
              textFillColor: 'transparent',
              animation: 'fadeDown 2s ease-in-out',
              '@keyframes fadeDown': {
                '0%': { opacity: 0, transform: 'translateY(-20px)' },
                '100%': { opacity: 1, transform: 'translateY(0)' },
              },
            }}
          >
            <b>GAME ZONE</b>
          </Typography>

          {/* Soft Light Overlay */}
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.3)',
              borderRadius: '15px',
              boxShadow: '0px 4px 20px rgb(255, 255, 255)',
            }}
          />
        </SwiperSlide>

        {/* Third Slide */}
        <SwiperSlide
          style={{
            backgroundImage: `url(${FirstBanner})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '50vh',
            borderRadius: '15px',
          }}
        >
          <Box
            sx={{
              p: 5,
              backdropFilter: 'brightness(0.7)',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
            }}
          ></Box>
        </SwiperSlide>

        {/* Fourth Slide */}
        <SwiperSlide
          style={{
            backgroundImage: `url(${Banner3})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '50vh',
          }}
        ></SwiperSlide>
      </Swiper>
    </Box>
  );
}

export default HeroSection;
